import React, {useEffect, useRef, useState} from 'react';
import data from '../../Font/DuckIcon/src/icon.json';
import {useOutsideClick} from "../../../slide/checker";
import Tabs from "../../DuckReact/Tabs";
import {SlideElement} from "../animate/AnimateElement";
import {Link} from "react-router-dom";
import HiLightCode from "./Support/hiLightCode";
import {Highlight, themes} from "prism-react-renderer";
import FormatHTMLString from "./Controler/JSXtoString";

const DuckIcon = () => {

    useEffect(() => {
        document.title = "Duck Icon của Hi nè";
    })
    const [copy, setCopy] = useState(false)
    const [icon, setIcon] = useState(false)
    const [showCode, setCode] = useState(true)

    const [search, setSearch] = useState({
        group: '',
        icon: ''
    });
    const [tab, setTab] = useState(0)
    const tabs = [
        {
            tabId: 0,
            tabName: "Tài Liệu"
        },
        {
            tabId: 1,
            tabName: "Icons"
        }
    ]
    const handleClick = (newIcon) => {
        if (!e) var e = window.event;
        e.stopPropagation();
        if (icon !== newIcon)
            setIcon(newIcon)
        else
            setIcon(false)
    }
    const handleClickOutside = () => {
        setIcon(false)
    }
    const handleSearch = (e) => {
        setSearch(e.target.value);
    };


    function changeTab(value) {
        if (value === tab) {
        } else
            setTab(value)
        console.log(value)
    }

    const [selectedGroups, setSelectedGroups] = useState([]);
    // Hàm lọc ra các icon dựa trên trạng thái search và các nhóm đã chọn
    const filteredGroups = data.map(group => ({
        ...group,
        listIcon: group.listIcon.filter(icon => icon.icon.includes(search.icon))
    })).filter(group =>
        (search.group === '' || group.group.includes(search.group)) &&
        (search.icon === '' || group.listIcon.length > 0) &&
        (selectedGroups.length === 0 || selectedGroups.includes(group.group))
    );
    // Hàm xử lý khi bấm vào một group chip
    const handleGroupChipClick = (group) => {
        if (selectedGroups.includes(group)) {
            // Nếu group đã chọn, loại bỏ nó khỏi danh sách
            setSelectedGroups(selectedGroups.filter(selectedGroup => selectedGroup !== group));
        } else {
            // Nếu group chưa được chọn, thêm nó vào danh sách
            setSelectedGroups([...selectedGroups, group]);
        }
    };
    useEffect(() => {
        console.log(search);
        // Thực hiện các side effect khác ở đây nếu cần
    }, [search]);
    const codeString = `<Icon icon={"${icon.icon}"}/>`
    const ref = useRef(null)
    const refClick = useOutsideClick(handleClickOutside)
    return (<div className="is-relative ">
            <div className="  is-flex vertical jt-center gapy-m">
                <div className="container-full">
                    <div className=" hero  rounded-t-l has-background is-flex jt-center align-center py-xxl ">
                        <img src="https://i.imgur.com/fKfrWXx.png" alt=""/>
                        <div className="container-l columns layout-2-1 s-vertical-revert align-center">

                            <div className="col">
                                <SlideElement>
                                    <div className="hi-3xl text-bold font-text">
                                        Nét đơn giản, sự thân thiện và sáng tạo
                                    </div>

                                </SlideElement>
                                <div className="columns vertical">

                                    <div className="text-xs col">Trang web sử dụng biểu tượng vịt như là một phần
                                        của
                                        thương
                                        hiệu của Hine Studio.
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <svg style={{width: "100%", height: "auto"}} viewBox="0 0 400 400" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M335.938 6.76579H64.0623C32.4183 6.76579 6.7658 32.4183 6.7658 64.0623V214.626H171.791V92.94C171.791 63.8599 195.365 40.2858 224.445 40.2858C253.525 40.2858 277.099 63.8599 277.099 92.94V99.2674L277.907 99.6173L323.647 119.421C332.961 122.613 332.961 135.785 323.647 138.976L310.677 143.42L310.67 143.422L310.222 143.576L310.221 143.576L307.462 144.521C305.407 145.225 305.133 148.019 307.012 149.109C308.695 150.085 308.695 152.516 307.012 153.492L281.026 168.564C279.51 169.444 278.211 170.098 277.099 170.545V328.88C277.099 357.316 260.411 381.854 236.294 393.234H335.938C367.582 393.234 393.234 367.581 393.234 335.937V64.0623C393.234 32.4183 367.582 6.76579 335.938 6.76579ZM206.143 400H335.938C371.318 400 400 371.318 400 335.937V64.0623C400 28.6817 371.318 0 335.938 0H64.0623C28.6817 0 0 28.6817 0 64.0623V335.937C0 343.899 1.45248 351.522 4.10694 358.555C10.9684 378.156 27.5053 393.207 47.999 397.969C53.1323 399.295 58.515 400 64.0623 400H205.865C205.903 400 205.941 400 205.979 400C206.033 400 206.088 400 206.143 400ZM206.905 393.228V392.792H201.047C188.256 390.469 178.557 379.273 178.557 365.812V221.392H182.208H270.334V328.88C270.334 364.113 242.02 392.732 206.905 393.228ZM270.334 214.626V92.94C270.334 67.5966 249.788 47.0516 224.445 47.0516C199.101 47.0516 178.557 67.5965 178.557 92.94V214.626H182.208H270.334ZM171.791 221.392V365.812C171.791 376.776 176.953 386.536 184.979 392.792H61.9189C57.6865 392.792 53.5673 392.31 49.6131 391.397C31.5748 386.71 16.991 373.456 10.466 356.238C9.00959 352.056 8.04794 347.642 7.65113 343.066C15.1125 344.429 22.7309 345.128 30.4211 345.128C64.0288 345.128 96.26 331.777 120.025 308.013L117.633 305.621L120.025 308.013C143.085 284.953 156.339 253.919 157.104 221.392H171.791ZM7.44498 336.142V221.792H30.4211H150.326C149.464 252.379 136.937 281.532 115.24 303.229C92.7448 325.724 62.2344 338.362 30.4211 338.362C22.652 338.362 14.9607 337.608 7.44498 336.142ZM305.268 138.121L305.269 138.121L321.454 132.575C324.671 131.473 324.671 126.924 321.454 125.822L321.203 125.736L320.959 125.63L277.907 106.99L277.906 120.293C277.888 119.849 277.815 119.186 277.563 118.431C277.728 118.933 277.886 119.694 277.892 120.576H277.906V120.58H277.905H277.892C277.894 120.914 277.874 121.264 277.825 121.624C277.876 121.296 277.905 120.948 277.905 120.58V151.308C277.905 154.354 277.775 157.252 277.667 159.674C277.632 160.446 277.6 161.169 277.574 161.833C277.562 162.161 277.552 162.471 277.543 162.763L277.631 162.712L299.499 150.028C297.918 145.481 299.998 139.927 305.268 138.121ZM277.906 120.576L277.906 120.293C277.911 120.401 277.912 120.496 277.912 120.576H277.906ZM277.684 167.049C277.683 167.049 277.68 167.04 277.675 167.018C277.681 167.038 277.684 167.049 277.684 167.049Z"
                                          fill="black"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container-full is-relative     ">
                    <div className="container-full is-sticky border-b" style={{top: "0%", zIndex: 2}}>
                        <div className="container-l    bg-white">
                            <Tabs tabs={tabs} handleClick={changeTab}></Tabs>
                        </div>
                    </div>

                    {tab === 0 ? <div className="container-l gap-l" style={{minHeight: "100vh"}}>
                            <div className="section  columns layout-1-1">
                                <div className=" gapy-l">
                                    <h3>
                                        Dành cho các nhà phát triển
                                    </h3>
                                    <div className="gapy-m section">
                                        <h1 className=" pb-m">
                                            Sử dụng CSS
                                        </h1>
                                        <div className="text-s">
                                            1. Sao chép toàn bộ <span className={"code"}>duck icon</span> thư mục vào dự án
                                            của
                                            bạn.
                                        </div>
                                        <div className="text-s">
                                            2. Ở trong thẻ <span
                                            className={"code"}>&#60;head&#62; &#60;/head&#62;</span> của file index.html,
                                            tạo đườn
                                            dẫn
                                            đến thư mục chứa file Duck Icon
                                        </div>

                                    </div>
                                    <div>
                                        <h1 className=" pb-m">
                                            Sử dụng React
                                        </h1>
                                        <div className="title-l pb-s">
                                            Cài đặt
                                        </div>
                                        <div className="rounded-m is-overflow">
                                            <Highlight
                                                theme={themes.oneDark}
                                                code={("npm install duckicon")}
                                                language="properties"
                                            >
                                                {({className, style, tokens, getLineProps, getTokenProps}) => (
                                                    <pre
                                                        style={{
                                                            flexGrow: "1",
                                                            overflowY: "auto",
                                                            borderRadius: "0", ...style
                                                        }}>
                                    {tokens.map((line, i) => (
                                        <div className={"is-flex"} key={i} {...getLineProps({line})}>
                                            {line.map((token, key) => (
                                                <span className={"text-l"} key={key} {...getTokenProps({token})} />
                                            ))}
                                        </div>
                                    ))}
                                </pre>
                                                )}
                                            </Highlight>

                                        </div>
                                    </div>
                                    <div>
                                        <div className="title-l">
                                            Sử dụng
                                        </div>
                                        <div className="is-flex align-center">
                                            Để có icon
                                            <Icon className=" text-xxl mx-s" icon={"campfire"}/>
                                            sử dụng đoạn code sau
                                        </div>

                                        <div className="rounded-m is-overflow">
                                            <Highlight
                                                theme={themes.oneDark}
                                                code={("import { DuckIcon } from 'duck/icon'" +
                                                    "\n" +
                                                    "\n" +
                                                    "<DuckIcon className=\"text-xxl\" icon={\"campfire\"}/>")}
                                                language="jsx"
                                            >
                                                {({className, style, tokens, getLineProps, getTokenProps}) => (
                                                    <pre
                                                        style={{flexGrow: "1", overflowY: "auto", borderRadius: "0", ...style}}>
                                    {tokens.map((line, i) => (
                                        <div className={"is-flex"} key={i} {...getLineProps({line})}>
                                            {line.map((token, key) => (
                                                <span className={"text-l"} key={key} {...getTokenProps({token})} />
                                            ))}
                                        </div>
                                    ))}
                                </pre>
                                                )}
                                            </Highlight>

                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="section gap-s">
                                <h1>
                                    Dành cho Designer
                                </h1>
                                <div className="title-l">
                                    Sử dụng Figma
                                </div>
                                <div className="text-s">
                                    Truy cập đường link bên dưới, tạo bản sao vào dự án của bạn
                                </div>
                                <div className="text-s">
                                    <p><Link className={"text-primary"} to="https://hine.studio/r/duck-icon">https://hine.studio/r/duck-icon</Link>
                                    </p>

                                </div>
                            </div>
                        </div> :
                        <div className="columns  container-xl layout-1-3 s-vertical" style={{minHeight: "100vh"}}>
                            <div className="col is-relative ">
                                <div className=" is-sticky p-m" style={{top: "75px", zIndex: 1}}>
                                    <div className="field">
                                        <div className="label">Tìm kiếm</div>
                                        <input value={search.icon} placeholder={"tìm kiếm icon..."} type="text"
                                               onChange={(e) => setSearch({...search, icon: e.target.value})}/>
                                        <div onClick={() => setSearch({...search, icon: ''})} className="info-icon">
                                            <Icon icon={`multiply`}/>
                                        </div>
                                    </div>
                                    <div className="accordion">
                                        <div className="is-flex jt-between  px-m">
                                            <div className="title-l">Filter</div>
                                            <div style={{minWidth: "30px"}} onClick={() => setCode(!showCode)}
                                                 className="btn  btn-s btn-ghost ">
                                                {showCode ? <Icon icon={"down"}></Icon> :
                                                    <Icon icon={"up-direction"}></Icon>}
                                            </div>
                                        </div>

                                        <div className={`accordion-item ${showCode ? "active" : ""}`}>
                                            <div className="  is-flex-wrap gap-xs p-m">
                                                {data.flatMap((item, index) =>
                                                    <div key={index} onClick={() => handleGroupChipClick(item.group)}
                                                         className={`chips text-capitalize ${selectedGroups.includes(item.group) ? "active" : ""}`}>{item.group}</div>
                                                )}
                                            </div>
                                        </div>
                                    </div>


                                </div>

                            </div>
                            <div className="col border-l border-r ">
                                {filteredGroups.map((group, groupIndex) => (
                                    <div key={groupIndex} className=" gap-m p-m">
                                        <h3 className={"text-capitalize"}>{group.group}</h3>
                                        <div className="is-flex-wrap  gap-s">
                                            {group.listIcon.map((icon, iconIndex) => (
                                                <div onClick={() => handleClick(icon)} key={iconIndex} title={icon.icon}
                                                     className="btn  btn-l btn-ghost ">
                                                    <Icon className={` text-xxl`} icon={icon.icon}></Icon>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ))}

                            </div>
                        </div>}


                </div>


            </div>
            {icon ? <div ref={ref} className="bottom-menu bg-mute expand-vertical">
                <div className=" p-s">
                    <div className="is-flex gapx-s jt-center align-center">
                        <div className={`pl-l  text-xxl text-white icon icon-${icon.icon}`}/>
                        <div className="text-white text-l text-capitalize"
                             style={{minWidth: "200px"}}>{icon.icon.replace("-", " ")}</div>
                        {copy ? <div className="btn btn-l btn-outline  ">Đã sao chép</div> :
                            <div className="btn btn-l btn-ghost text-white btn-has-icon" onClick={async (e) => {
                                e.stopPropagation()
                                var delayInMilliseconds = 1000; //1 second
                                setCopy(true)
                                CopyToClipboard(codeString)
                                setTimeout(function () {
                                    setCopy(false)
                                    console.log(copy)
                                }, delayInMilliseconds);
                            }}>
                                <Icon className={"text-l"} icon={"copy"}></Icon>
                            </div>}
                    </div>


                </div>
            </div> : null}
        </div>

    );
};


function Icon({className, icon}) {
    return (
        <div className={` icon icon-${icon} ${className}`}></div>
    );
}

const unsecuredCopyToClipboard = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
        document.execCommand('copy')
    } catch (err) {
        console.error('Unable to copy to clipboard', err)
    }
    document.body.removeChild(textArea)
};

/**
 * Copies the text passed as param to the system clipboard
 * Check if using HTTPS and navigator.clipboard is available
 * Then uses standard clipboard API, otherwise uses fallback
 */
const CopyToClipboard = (content) => {
    if (window.isSecureContext && navigator.clipboard) {
        navigator.clipboard.writeText(content);
    } else {
        unsecuredCopyToClipboard(content);
    }
};
export default DuckIcon;
export {Icon, CopyToClipboard};